import { mapGetters, mapActions } from 'vuex'

import { isArray, isEmpty, trim, getByteLen } from '@/common/js/utils'

import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import cityData from '@/data/toutiao/city_province'
import tagsData from '@/data/toutiao/ad_tag'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'

import Affix from '@/components/affix.vue'
import Moduler from '@/components/moduler'
import InputLen from '@/components/input/input-len'
import ErrorPop from '@/components/err-pop'
import InputNumberPlus from '@/components/input/input-number-plus'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'

export default {
  components: { Affix, Moduler, InputLen, ErrorPop, InputNumberPlus, AutoComplete },
  computed: {
    ...mapGetters('Robot', [
      'subCurrent',
      'subModules'
    ])
  },
  methods: {
    ...mapActions('Robot', [
      'refreshDocTitle'
    ]),
    invalid (rules) {
      const arr = []
      const multRuleName = name => {
        const rule = name.split('/')
        if (rule.length > 3) return this[rule[0]][rule[1]][rule[2]][rule[3]]
        else if (rule.length > 2) return this[rule[0]][rule[1]][rule[2]]
        else return this[rule[0]][rule[1]]
      }
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? multRuleName(rule.name) : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? multRuleName(rule.relyon) : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (param && rule.max < length) {
          const msg = `${rule.desc}不能多于${rule.max}个字符`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }
        if (param && rule.min > length) {
          const msg = `${rule.desc}不能少于${rule.min}个字符`
          this.formErr = true
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    cannel () {
      this.closePageForm()
    },
    closePageForm () {
      this.$Message.info({
        content: '页面将 2 秒后自动关闭',
        duration: 2,
        onClose: () => {
          window.close()
        }
      })
    }
  },
  data () {
    return {
      loading: null,
      formErr: null,
      errRes: [],
      media: this.$store.state.Robot.media,
      opId: Number(this.$store.state.Robot.account),
      orignData: {
        cityData: cityData,
        brandData: brandData,
        tagsData: tagsData,
        gategoryData: gategoryData,
        articleData: articleData,
        autotendData: autotendData
      }
    }
  }
}
